document.addEventListener('DOMContentLoaded', function () {
  var chips = document.querySelectorAll('[data-mm2-filter]');
  var tiles = document.querySelectorAll('[data-mm2-tile]');
  var emptyMsg = document.querySelector('[data-mm2-empty]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.remove('is-active'); });
      chip.classList.add('is-active');
      var f = chip.getAttribute('data-mm2-filter');
      var visible = 0;
      tiles.forEach(function (t) {
        var cats = (t.getAttribute('data-mm2-cat') || '').split(' ');
        var show = f === 'all' || cats.indexOf(f) !== -1;
        t.style.display = show ? '' : 'none';
        if (show) visible++;
      });
      if (emptyMsg) emptyMsg.style.display = visible === 0 ? 'block' : 'none';
    });
  });
  var led = document.querySelector('[data-mm2-led]');
  if (led) {
    var raw = led.getAttribute('data-mm2-led-values') || '';
    var values = raw.split(',').map(function (v) { return v.trim(); }).filter(Boolean);
    if (values.length > 1) {
      var i = 0;
      setInterval(function () {
        i = (i + 1) % values.length;
        led.textContent = values[i];
      }, 2000);
    }
  }
  var sticky = document.querySelector('[data-mm2-sticky]');
  var hero = document.querySelector('[data-mm2-hero-anchor]');
  if (sticky && hero) {
    window.addEventListener('scroll', function () {
      var trigger = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > trigger) { sticky.classList.add('is-visible'); } else { sticky.classList.remove('is-visible'); }
    });
  }

  /* ---- Toast: appears the instant an item is added, before the redirect to
     /cart, so the coupon offer is impossible to miss — not just something
     they might notice once they land on the cart page. Uses sessionStorage
     to track how many INDIVIDUAL (non-mayoreo) cards were added this
     session, so the message is accurate even across page loads. ---- */
  function showToast(html, tone) {
    var existing = document.querySelector('.mm2-toast');
    if (existing) existing.remove();
    var toast = document.createElement('div');
    toast.className = 'mm2-scope mm2-toast' + (tone === 'success' ? ' mm2-toast-success' : '');
    toast.innerHTML = html;
    document.body.appendChild(toast);
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    return toast;
  }

  function getIndividualCount() {
    return parseInt(sessionStorage.getItem('mm2_individual_count') || '0', 10);
  }

  function addToCart(variantId, btn, isWholesale) {
    if (!variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Agregando…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: variantId, quantity: 1 }) })
      .then(function (res) { if (!res.ok) throw new Error('No se pudo comprar'); return res.json(); })
      .then(function () {
        btn.textContent = '¡Agregado!';

        var toastHtml;
        var tone = 'default';

        if (isWholesale) {
          toastHtml = '<span class="mm2-toast-icon">✅</span><span><strong>¡Tarjeta agregada!</strong><br>Te llevamos a tu carrito…</span>';
        } else {
          var count = getIndividualCount() + 1;
          sessionStorage.setItem('mm2_individual_count', String(count));
          if (count >= 2) {
            toastHtml = '<span class="mm2-toast-icon">✅</span><span><strong>¡Tu cupón de 10% ya se aplicó!</strong><br>Por agregar 2 o más tarjetas individuales.</span>';
            tone = 'success';
          } else {
            toastHtml = '<span class="mm2-toast-icon">🎟️</span><span><strong>¡Agregada! Activa tu cupón de 10%</strong><br>Agrega una 2da tarjeta individual y se aplica solo, sin escribir nada.</span>';
          }
        }

        showToast(toastHtml, tone);

        setTimeout(function () {
          window.location.href = '/cart';
        }, 1600);
      })
      .catch(function () {
        btn.textContent = 'Error, reintenta';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
      });
  }

  document.querySelectorAll('[data-mm2-buy]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isWholesale = btn.getAttribute('data-mm2-wholesale') === 'true';
      addToCart(btn.getAttribute('data-variant-id'), btn, isWholesale);
    });
  });
});
